// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  clientID: "GOVCOEntidades",
  authIssuer: 'https://preautenticaciondigital.and.gov.co',
  serverUrl: 'https://preapi-interno.www.gov.co/api/entidades/',
  serverIntegracion: 'https://preapi-interno.www.gov.co/api/integracion-sedes/IntegracionSedes/entidad/',
  serverUrlBuscador: "https://prebuscador.www.gov.co/api/v1",
  serverCategorias: "https://preapi-interno.www.gov.co/api/categorias-subcategorias/",
  severApiCross: "https://preapi-interno.www.gov.co/api/cross/"
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

